export const AKAMAI_DC = "x-akamai-device-characteristics";
export const AKAMAI_DC_KIND = {
  isMobile: "is_mobile",
  isTablet: "is_tablet",
};
const isTablet = (akamaiDCHeaders: Record<string, string>) =>
  akamaiDCHeaders?.[AKAMAI_DC_KIND.isTablet];
const isMobile = (akamaiDCHeaders: Record<string, string>) =>
  akamaiDCHeaders?.[AKAMAI_DC_KIND.isMobile];

export function akamaiGetDevice(
  headers: Record<string, string | string[]> = {}
) {
  const akamaiDCHeaders = akamaiDCparser(headers[AKAMAI_DC] as string);

  const isTabletHeader = isTablet(akamaiDCHeaders) || headers["tablet-device"];
  const isMobileHeader = isMobile(akamaiDCHeaders) || headers["mobile-device"];

  let device: "desktop" | "tablet" | "mobile" = "desktop";

  switch ("true") {
    case isTabletHeader:
      device = "tablet";
      break;
    case isMobileHeader:
      device = "mobile";
      break;
    default:
      device = "desktop";
      break;
  }
  return device;
}

export const akamaiDCparser = (header: string | undefined) => {
  const separator = ";";
  if (!header) {
    return {};
  }
  try {
    const akamaiDCHeader = Object.fromEntries(
      header
        .split(separator)
        .map((v) => v.split(/=(.*)/).map(decodeURIComponent))
    );
    return akamaiDCHeader;
  } catch (e) {
    return {};
  }
};
